<template>
    <div d-flex justify-center>
        <el-date-picker
            v-model="localValue"
            type="monthrange"
            format="MM/yyyy"
            value-format="yyyy-MM"
            align="center"
            unlink-panels
            start-placeholder="С"
            end-placeholder="ПО"
            :picker-options="pickerOptions"
            style="width: 100%;"
            >
        </el-date-picker>
    </div>
</template>

<script>
  export default {
    props: ['value'],
    data() {
      return {
        localValue: this.value,
        pickerOptions: {
          disabledDate(dt) {
            return dt.getTime() > new Date().getTime();
          },
          shortcuts: [
          {
            text: 'Текущий месяц',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          },
          {
            text: 'Прошлый месяц',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              end.setMonth(end.getMonth() - 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Прошлый квартал',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              end.setMonth(end.getMonth() - 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Прошлый год',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setFullYear(start.getFullYear() - 1);
              start.setMonth(start.getMonth() - 1);
              end.setMonth(end.getMonth() - 2);
              picker.$emit('pick', [start, end]);
            }
          },
          ]
        },
      };
    },
    watch: {
      localValue(newVal) {
        this.$emit('input', newVal);
      }
    },
    created() {
      let today = `${new Date().getFullYear().toString().padStart(2, '0')}-${(new Date().getMonth() + 1).toString().padStart(2, '0')}`;
      this.localValue = [today, today];
    }
  };
</script>

<style>

.el-date-picker {
  width: 100%;
}

.el-picker-panel__body {
  width: 80% !important;
}

.el-picker-panel__body {
  margin-left: 150px !important;
}

.el-picker-panel__sidebar {
  width: 20% !important;
}

.v-application .headline {
  font-size: 1.25rem !important;
}

</style>